import React, { useState } from 'react';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    Container,
    Grid,
    Button,
    CircularProgress
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { LOGOUT } from 'ConstComponents';
import { UpdateTIDMID as UPDATE } from 'Components/Api/NSDLOnboardingAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const ManualTIDMIDUpdate = ({ OnbaordingID, TerminalID = '', MerchantID = '', onDismissCallback }) => {
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [formObject, setFormObject] = useState({
        OnboardingID: OnbaordingID,
        TID: TerminalID,
        MID: MerchantID
    });

    const UpdateStatus = async (requestObj) => {
        setLoading(true);
        setIsError(false);
        var response = await UPDATE(requestObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);
        onDismissCallback(false);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        setSubmitting(false);
        var requestObj = JSON.stringify(values);
        UpdateStatus(requestObj);
        setSubmitting(true);
        resetForm(formObject);
    };

    const FormValidationSchema = Yup.object({
        TID: Yup.string()
            .trim()
            .required('Please enter a valid TID'),
        MID: Yup.string()
            .trim()
            .required('Please enter a valid MID'),
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ setFieldValue, resetForm }) => (
                    <Form>
                        <Grid container spacing={3} direction="column">
                            <Grid item xs={12}>
                                <MaterialTextField
                                    label="TID"
                                    name="TID"
                                    type="text"
                                    length={500}
                                    placeholder="Enter TID"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MaterialTextField
                                    label="MID"
                                    name="MID"
                                    type="text"
                                    length={500}
                                    placeholder="Enter MID"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Button
                                            type="submit"
                                            className={classes.CustomPrimaryButtonStyle}
                                            disabled={loading}
                                            fullWidth
                                            style={{
                                                height: '56px',
                                                fontSize: '16px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Update
                                            {loading && (
                                                <CircularProgress
                                                    size={20}
                                                    style={{ marginLeft: 8 }}
                                                />
                                            )}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Button
                                            type="button"
                                            onClick={() => resetForm()}
                                            className={classes.CustomDangerButtonStyle}
                                            fullWidth
                                            style={{
                                                height: '56px',
                                                fontSize: '16px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </CustomContainer>
    );
};
